import { render, staticRenderFns } from "./LostItemDetail.vue?vue&type=template&id=62b63778&scoped=true"
import script from "./LostItemDetail.vue?vue&type=script&lang=js"
export * from "./LostItemDetail.vue?vue&type=script&lang=js"
import style0 from "./LostItemDetail.vue?vue&type=style&index=0&id=62b63778&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b63778",
  null
  
)

export default component.exports